$.lui("comp", ".comp_downloads", function(selector){

    selector.on("click", "[data-toggle-detail]", function(){
        $(this).toggleClass("state--active").closest(".elm_comp_inner").find(".elm_inner_items").slideToggle(300);
    });
});